// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formErr {
    max-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 0%;
    align-items: center;
    cursor: default;
}

.formErr_img {
    width: 60vw;
    height: 32.5vh;
    object-fit: contain;
}

.formErr_p {
    text-align: center;
    max-width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/components/form/formErr/styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":[".formErr {\n    max-height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 0 0%;\n    align-items: center;\n    cursor: default;\n}\n\n.formErr_img {\n    width: 60vw;\n    height: 32.5vh;\n    object-fit: contain;\n}\n\n.formErr_p {\n    text-align: center;\n    max-width: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
